import { gql } from '@apollo/client'

export const REGION_LENGTH_QUERY = gql`
    query RegionCount($chrom: String!, $start: Int!, $stop: Int!) {
        regionCount(chrom: $chrom, start: $start, stop: $stop)
    }
`
